
import {initialTaskDetailState, initialTasksListState, ITaskDetailState, ITasksListState} from "../../state/tasks/tasks.state";
import {ETasksActions, TasksActions} from "../../actions/tasks/tasks.actions";
import {combineReducers} from "@ngrx/store";

export const tasksListReducers = (
  state = initialTasksListState,
  action: TasksActions
):ITasksListState =>{
  switch (action.type) {
    case ETasksActions.GetTasksList:
      return {
        ...state
      };
    case ETasksActions.GetTasksListSuccess:
      return {
        ...state,
        data:action.payload,
        isLoaded:true
      };
    case ETasksActions.GetTasksListFailure:
      return {
        ...state,
        isLoaded:false
      };

    default:
      return state;
  }
};
export const taskDetailReducers = (
  state = initialTaskDetailState,
  action: TasksActions
):ITaskDetailState =>{
  switch (action.type) {
    case ETasksActions.GetTasksList:
      return {
        ...state
      };
    case ETasksActions.GetTasksListSuccess:
      return {
        ...state,
        isLoaded: true
      };
    case ETasksActions.GetTasksListFailure:
      return {
        ...state,
        isLoaded: false
      };

    default:
      return state;
  }
};


